<style></style>
<template>
  <div class="col-lg-12 d-print-none" style="padding: 20px">
    <div>
      <div class="main-card mb-3 card" style="margin-left: 10px">
        <div class="card-body">
          <h5 class="card-title">
            레벨테스트 결과
            <div
              class="sub_title"
              style="
                margin-bottom: 20px;
                color: #333;
                font-size: 13px;
                border: 1px solid #ccc;
                background: #f8f8f8;
                height: 30px;
                text-align: right;
                position: absolute;
                right: 20px;
                top: 10px;
                padding: 2px 10px;
              "
            >
              레벨테스트 관리 → 레벨테스트 결과
            </div>
          </h5>
          <query-grid :config="config" ref="qg">
          <template #items="props">
            <tr v-for="(record, i) in props.records" v-bind:key="record.id">
              <td scope="row">{{ record.id }}</td>
              <td>
                {{ record.createdAt }}
              </td>
              <td scope="col">
                <Business :biz="record.business" />
              </td>
              <td>{{ record.name }}</td>
              <td scope="col">{{ record.job }}</td>
                <td scope="col">{{ record.grade }}</td>
                <td scope="col">
                  <template v-if="record.status != 'STARTED'"
                    >{{ record.score }}점</template
                  ><template v-else>진행 중</template>
                </td>
                <td scope="col">
                  <template v-if="record.status != 'STARTED'">{{
                    record.took
                  }}</template>
                </td>
                <td scope="col">
                  <!--button class="btn btn-warning btn-sm">출력</button-->
                  <button
                    class="btn btn-info btn-sm"
                    style="margin-top: 2px"
                    @click="retrieveDetails(record)"
                    data-bs-toggle="modal"
                    data-bs-target="#leveltest_details"
                  >
                    문제
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    style="margin-top: 2px"
                    @click="TestDetails(record)"
                  >
                    Report
                  </button>
                </td>
            </tr>
          </template>
          <template #actions>
          </template>
        </query-grid>
        </div>
      </div>
    </div>

    <div class="modal" id="leveltest_details" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">레벨테스트 문제 및 정답 조회</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <table
              class="table test-table"
              v-if="details.questions"
              style="font-size: 14px"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>Question</th>
                  <th>descript</th>
                  <th>Correct</th>
                  <th>Student</th>
                  <th>Correct</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(question, i) in details.questions" :key="i">
                  <td>{{ i + 1 }}</td>
                  <td style="text-align: left" v-html="question.question"></td>
                  <td>
                    <span>{{ question.description }} </span>
                  </td>
                  <td>{{ question.correct_answer }}</td>
                  <td>{{ question.user_answer }}</td>
                  <td>
                    <span v-if="question.is_correct" style="color: #de1a3e"
                      >O</span
                    ><span v-if="!question.is_correct" style="color: #0b82ea"
                      >X</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal" id="leveltest_report" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Report</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body" v-if="details.name" id="modalPrint">
          <div style="width: 100%">
            <table
              width="99%"
              border="0"
              class="table score_table"
              style="text-align: center; margin-top: 0"
            >
              <tbody>
                <tr class="vlue">
                  <td colspan="4" style="background: #c2edff" class="vlue">
                    <span class="test_title">Student's Information</span>
                  </td>
                </tr>
                <tr>
                  <th width="260">NAME</th>
                  <td>
                    <span>{{ details.name }}</span>
                  </td>
                  <th>PHONE</th>
                  <td width="229">{{ details.phone }}</td>
                </tr>
                <tr>
                  <th width="260">PLACE OF TEST</th>
                  <td>{{ this.$root.businesses[0].name }}</td>
                  <th width="460" colspan="2">TOTAL SCORE</th>
                </tr>
                <tr>
                  <th width="260">LEVEL</th>
                  <td>{{ details.grade }}</td>
                  <td
                    width="460"
                    colspan="2"
                    rowspan="3"
                    class="score"
                    style="font-size: 80px; font-weight: bold"
                  >
                    {{
                      Math.floor(
                        ((details.reading_correct_cnt +
                          details.listening_correct_cnt) /
                          (details.questions_listening.length +
                            details.questions_reading.length)) *
                          100
                      )
                    }}
                  </td>
                </tr>
                <tr>
                  <th width="260">START TIME</th>
                  <td>{{ details.startedAt }}</td>
                </tr>
                <tr>
                  <th width="260">FINISH TIME</th>
                  <td>{{ details.endedAt }}</td>
                </tr>
              </tbody>
            </table>

            <table width="99%" border="0" style="text-align: center">
              <colgroup>
                <col style="width: 100px" />
                <col style="width: 300px" />
                <col style="width: 100px" />
              </colgroup>
              <tbody>
                <tr>
                  <td
                    colspan="2"
                    style="background: #c2edff; text-align: center"
                    class="vlue"
                  >
                    <span class="test_title">Placement Test Result</span>
                  </td>
                  <td style="background: #c2edff; text-align: center">
                    <span class="test_title" style="font-size: 16px"
                      >Score</span
                    >
                  </td>
                </tr>
                <tr class="listening">
                  <td bgcolor="#FFFDF0" style="vertical-align: middle">
                    <span
                      style="font-size: 16px; font-weight: bold; color: #0881d8"
                      >Listening</span
                    >
                  </td>
                  <td bgcolor="#FFFDF0" style="text-align: left">
                    Listening reflects the ability to understand specific
                    details and main ideas from everyday speech. The score is
                    based on the ability to track meaning and infer the message
                    from English that is spoken at a conversational pace.
                  </td>
                  <td
                    bgcolor="#FFFDF0"
                    style="
                      vertical-align: middle;
                      font-size: 16px;
                      font-weight: bold;
                    "
                  >
                    {{ details.listening_correct_cnt }}/{{
                      details.questions_listening.length
                    }}
                  </td>
                </tr>
                <tr bgcolor="#FFFDF0" class="listening">
                  <td
                    style="
                      vertical-align: middle;
                      font-size: 16px;
                      font-weight: bold;
                      color: #0881d8;
                    "
                  >
                    Reading
                  </td>
                  <td style="text-align: left">
                    Reading reflects the ability to understand written English
                    texts on the topics provided. The score is based on the
                    ability to operate at functional speeds to extract details
                    and main ideas, infer the message, and construct meaning.
                  </td>
                  <td
                    style="
                      vertical-align: middle;
                      font-size: 16px;
                      font-weight: bold;
                    "
                  >
                    {{ details.reading_correct_cnt }}/{{
                      details.questions_reading.length
                    }}
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              border="0"
              class="table"
              style="border-bottom: 1px solid #eee"
            >
              <tr align="center">
                <th
                  height="25"
                  colspan="10"
                  style="background: #c2edff; text-align: center"
                  class="vlue"
                >
                  <span class="test_title">Detailed test result</span>
                </th>
              </tr>

              <tr align="center" bgcolor="#FFFFFF">
                <th
                  align="center"
                  width="94"
                  style="vertical-align: middle; background: #f3fffe"
                >
                  Listening
                </th>
                <td colspan="9" align="center">
                  <!--결과표시-->
                  <table class="table" style="border-bottom: 1px solid #ccc">
                    <tr align="center" bgcolor="#FFFFFF">
                      <th width="70">No.</th>
                      <th width="370">CRITERIA</th>
                      <th width="51">MARK</th>
                      <th width="100" colspan="3">NATIONAL AVERAGE</th>
                    </tr>

                    <tr
                      align="center"
                      bgcolor="#FFFFFF"
                      v-for="(question, i) in details.questions_listening"
                      :key="i"
                    >
                      <td width="68" height="18" align="center">{{ i + 1 }}</td>
                      <td width="272" align="center">
                        {{ question.description }}
                      </td>
                      <td width="50" align="center">
                        <span v-if="question.is_correct" style="color: #de1a3e"
                          >O</span
                        ><span
                          v-if="!question.is_correct"
                          style="color: #0b82ea"
                          >X</span
                        >
                      </td>

                      <td width="200" align="center">
                        <div class="progress" style="width: 200px">
                          <div
                            class="progress-bar progress-bar-striped bg-warning"
                            role="progressbar"
                            :style="{
                              width: question.correct_percent * 2 + 'px',
                            }"
                          ></div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>

            <table class="table" style="border-bottom: 1px solid #eee">
              <tr align="center" bgcolor="#FFFFFF">
                <th
                  align="center"
                  width="94"
                  style="vertical-align: middle; background: #f3fffe"
                >
                  Reading
                </th>
                <td colspan="9" align="center">
                  <!--결과표시-->
                  <table class="table" style="border-bottom: 1px solid #eee">
                    <tr align="center" bgcolor="#FFFFFF">
                      <th width="70">No.</th>
                      <th width="370">CRITERIA</th>
                      <th width="51">MARK</th>
                      <th width="100" colspan="6">NATIONAL AVERAGE</th>
                    </tr>

                    <tr
                      align="center"
                      bgcolor="#FFFFFF"
                      v-for="(question, i) in details.questions_reading"
                      :key="i"
                    >
                      <td width="68" height="18" align="center">{{ i + 1 }}</td>
                      <td width="272" align="center">
                        {{ question.description }}
                      </td>
                      <td width="50" align="center">
                        <span v-if="question.is_correct" style="color: #de1a3e"
                          >O</span
                        ><span
                          v-if="!question.is_correct"
                          style="color: #0b82ea"
                          >X</span
                        >
                      </td>

                      <td width="200" align="center">
                        <div class="progress" style="width: 200px">
                          <div
                            class="progress-bar progress-bar-striped bg-danger"
                            role="progressbar"
                            :style="{
                              width: question.correct_percent * 2 + 'px',
                            }"
                          ></div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            onclick="window.print()"
          >
            프린트
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import axios from "axios";
import print from "print-js";
export default {
  name: "Home",
  components: {
    Tree,
    Business,
    QueryGrid,
  },
  mounted() {
    this.$refs.qg.search();
  },
  methods: {
    printIt() {
      print({
        type: "html",
        printable: "modalPrint",
        scanStyles: true,
      });
    },
    search() {
      axios
        .get("/leveltest?limit=10&offset=" + this.offset)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.records = response.data.result;
            this.total = response.data.total;
          }
        });
    },
    retrieveDetails(record, split) {
      this.details = {};
      var extras = "?";
      if (split) {
        extras += "&split=y";
      }
      axios.get("/leveltest/" + record.id + extras).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.details = response.data.result;

          var listening_correct = 0;
          var reading_correct = 0;

          this.details.questions_reading.forEach((element) => {
            if (element.is_correct) {
              reading_correct++;
            }
          });

          this.details.questions_listening.forEach((element) => {
            if (element.is_correct) {
              listening_correct++;
            }
          });

          this.details.reading_correct_cnt = reading_correct;
          this.details.listening_correct_cnt = listening_correct;
        }
      });
    },
    TestDetails(record) {
      if(record.status == 'STARTED'){
        $.notify(
          {
            // options
            message: "생성 실패하였습니다. " ,
          },
          {
            // settings
            type: "danger",
            z_index: 9999,
          }
        );
      }
      else{
        window.open('https://bizstudy.useschool.co.kr/report/pls_report_result.asp?intNo=' + record.id ,'PLS Placement Report','width=1024,height=780,location=no,status=no,scrollbars=yes');
      }
    },
  },
  data() {
    return {
      config: {
        name: "클래스리스트",
        req_endpoint: "/leveltest",
        default_limit: 20,
        no_excel : true,
        search_fields: [
        {
            "id": "date_filter",
            "name": "날짜검색",
            "type": "date"
        },
          {
            "id": "school_filter",
            "name": "학년",
            "type": "switch",
            "filter_type": {
                "미취학": "미취학",
                "초등": "초등",
                "중등": "중등",
                "고등": "고등",
                "기타": "기타"
            }
          },
          {
            "id": "level_filter",
            "name": "응시레벨",
            "type": "switch",
            "filter_type": {
                "Phonics": "Phonics",
                "kinder": "kinder",
                "1": "L3",
                "2": "L4",
                "3": "L5",
                "4": "L6"
            }
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "전화번호/이름으로 검색",
          },
        ],
        columns: [
          {
            id: "id",
            sortable: true,
            name: "번호"
          },
          {
            id: "biz",
            name: "테스트일"
          },
          {
            id: "name",
            name: "구분"
          },
          {
            id: "head_name",
            name: "학생명",
          },
          {
            id: "class_day",
            name: "실제학년"
          },
          {
            id: "class_time",
            name: "응시레벨"
          },
          {
            id: "class_grade",
            name: "결과"
          },
          {
            id: "class_type",
            name: "소요시간"
          },
          {
            id: "class_level",
            name: "성적표"
          }
        ],
        extras_addon: () => {
          return '&filter_type=["CLASS"]';
        },
      },
      records: [],
      details: {},
      total: 0,
      offset: 0,
    };
  },
};
</script>
